/**
 * Client-side file download helpers.
 *
 * Extracted from adminService so the bulk-assignment wizard (and any future
 * export) can reuse the exact same mechanism instead of re-implementing it.
 */

/** Build a Blob from `content` and hand it to the browser as a download. */
export const triggerDownload = (
  content: string,
  filename: string,
  type: string
): void => {
  const blob = new Blob([content], { type });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

/** Quote a CSV cell when it contains a separator, a quote or a line break. */
export const escapeCsv = (value: unknown): string => {
  const text = value == null ? '' : String(value);
  return /[",\n]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
};

/** Join rows into a CSV body, escaping every cell. */
export const toCsv = (rows: Array<Array<unknown>>): string =>
  rows.map((row) => row.map(escapeCsv).join(',')).join('\n');
